import Placeholder from "../Placeholder";

function ProductDetailsPlaceholder() {
  return (
    <>
      <section className="products-main">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8 mt-20" style={{ position: "relative" }}>
              <div className="d-inline-block">
                <div className="d-dsk" style={{ marginRight: "50px" }}>
                  <Placeholder
                    variant="rectangular"
                    width={80}
                    height={80}
                    style={{ marginBottom: "10px" }}
                  />
                  <Placeholder
                    variant="rectangular"
                    width={80}
                    height={80}
                    style={{ marginBottom: "10px" }}
                  />
                  <Placeholder
                    variant="rectangular"
                    width={80}
                    height={80}
                    style={{ marginBottom: "10px" }}
                  />
                </div>
              </div>

              <Placeholder
                variant="rectangular"
                width={350}
                height={270}
                className="d-inline-bloc product-image-placeholderk"
              />

              <div className="authentication-text mt-40 d-dsk">
                <p className="text-black">
                  <Placeholder variant="text" width={200} />
                </p>
                <Placeholder variant="rectangular" width={500} height={200} />
              </div>
            </div>

            <div className="col-md-4">
              <div className="product-desc d-dsk">
                <h3>
                  <Placeholder variant="text" width={200} height={50} />
                </h3>
                <p className="text-black">
                  <Placeholder variant="text" />
                </p>
                <div className="price mt-30">
                  <Placeholder variant="text" width={200} />
                  <Placeholder variant="text" />
                </div>

                <div className="custom-option mt-20">
                  <Placeholder variant="text" height={50} />
                </div>

                <div className="add-to-cart-btn mt-20">
                  <Placeholder
                    variant="rectangular"
                    width={300}
                    height={50}
                    style={{ marginRight: "10px" }}
                  />

                  <Placeholder variant="circular" width={30} height={30} />
                </div>

                {/* Accordion Description */}
                <div className="description-accord mt-30">
                  <Placeholder
                    variant="rectangular"
                    height={50}
                    style={{ marginBottom: "10px" }}
                  />
                  <Placeholder
                    variant="rectangular"
                    height={50}
                    style={{ marginBottom: "10px" }}
                  />
                  <Placeholder
                    variant="rectangular"
                    height={50}
                    style={{ marginBottom: "10px" }}
                  />
                  <Placeholder
                    variant="rectangular"
                    height={50}
                    style={{ marginBottom: "10px" }}
                  />
                  <Placeholder
                    variant="rectangular"
                    height={50}
                    style={{ marginBottom: "10px" }}
                  />
                </div>

                <div className="share mt-30">
                  <ul>
                    <li>
                      <Placeholder variant="circular" width={30} height={30} />
                    </li>
                    <li>
                      <Placeholder variant="circular" width={30} height={30} />
                    </li>
                    <li>
                      <Placeholder variant="circular" width={30} height={30} />
                    </li>
                    <li>
                      <Placeholder variant="circular" width={30} height={30} />
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-12 p-0">
              <section className="product-name bg-mobile-light mt-sm-30 text-center d-mbl">
                <div className="container-fluid">
                  <div className="row">
                    <h3 className="text-black">
                      <Placeholder
                        variant="text"
                        width={150}
                        className="mx-auto"
                      />
                    </h3>
                    <p className="desc-text">
                      <Placeholder
                        variant="text"
                        width={200}
                        className="mx-auto"
                      />
                    </p>
                    <Placeholder
                      variant="text"
                      width={200}
                      className="mx-auto"
                    />

                    <Placeholder
                      variant="text"
                      width={200}
                      className="mx-auto"
                    />
                  </div>
                </div>
              </section>
            </div>

            <div className="col-12">
              {/* <!-- PRODUCTS-MAIN STARTS --> */}
              <section className="products-main mt-25 d-mbl">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="product-desc">
                        {/* Cusotm Option Starts */}

                        {/* Cusotm Option Ends */}

                        {/* Accordion Description Starts */}
                        <div>
                          <Placeholder
                            variant="rectangular"
                            height={40}
                            style={{ marginBottom: "20px" }}
                          />
                          <Placeholder
                            variant="rectangular"
                            height={50}
                            style={{ marginBottom: "10px" }}
                          />
                          <Placeholder
                            variant="rectangular"
                            height={50}
                            style={{ marginBottom: "10px" }}
                          />
                          <Placeholder
                            variant="rectangular"
                            height={50}
                            style={{ marginBottom: "10px" }}
                          />
                          <Placeholder
                            variant="rectangular"
                            height={50}
                            style={{ marginBottom: "10px" }}
                          />
                        </div>
                        {/* Accordion Description Ends */}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/* <!-- PRODUCTS-MAIN ENDS --> */}

              <div className="clearfix"></div>

              {/* <!-- AUTHENTICATED BY STARTS --> */}
              <section className="authenticated-by spacer d-mbl">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      <h5 className="text-black text-center">
                        <Placeholder
                          variant="text"
                          width={200}
                          className="mx-auto"
                        />
                      </h5>
                      <Placeholder
                        variant="rectangular"
                        width={300}
                        height={200}
                        className="bottom-product-page-placeholder-extra-content"
                      />
                    </div>
                  </div>
                </div>
              </section>
              {/* <!-- AUTHENTICATED BY ENDS --> */}
            </div>
          </div>
        </div>
      </section>

      <div className="clearfix"></div>

      {/* Recently Viewed Products Section */}
      {/* <RecentlyViewedProducts /> */}

      <div className="clearfix"></div>

      <div className="spacer-grey"></div>

      <div className="clearfix"></div>

      {/* Related Products Section */}
      {/* <RelatedProducts relatedProducts={relatedProducts} /> */}
    </>
  );
}

export default ProductDetailsPlaceholder;
